














import Vue from "vue";
import Component from "vue-class-component";
import Hero from "@/components/home/Hero.vue";
import UnitSummary from "@/components/home/UnitSummary.vue";
import AffiliatedCommunities from "@/components/home/AffiliatedCommunities.vue";
import NextEvent from "@/components/home/NextEvent.vue";
import UnitStats from "@/components/home/UnitStats.vue";
import Moodboard from "@/components/home/Moodboard.vue";

@Component({
  components: { Hero, UnitSummary, AffiliatedCommunities, NextEvent, UnitStats, Moodboard },
  metaInfo: {
    title: "Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "The Newfound Pioneer Corps is an Arma 3 unit focussing on playing lots of different settings in regular events. Become an NPC today!" },
      { vmid: "og:title", property: "og:title", content: "Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "The Newfound Pioneer Corps is an Arma 3 unit focussing on playing lots of different settings in regular events. Become an NPC today!" },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/" },
    ],
  },
})
export default class Home extends Vue {}
